import { defineMessages } from "react-intl";
const messages = defineMessages({
    peekAdminTitle: {
        id: "app.peekAdmin.title.text",
        defaultMessage: "Peek Admin",
    },
    peekAdminCommunitiesLabel: {
        id: "app.peekAdmin.communities.label.text",
        defaultMessage: "Communities",
    },
    peekAdminUsersLabel: {
        id: "app.peekAdmin.users.label.text",
        defaultMessage: "Users",
    },
    peekAdminOrganizationsLabel: {
        id: "app.peekAdmin.organizations.label.text",
        defaultMessage: "Organizations",
    },
    peekAdminMagicButtonsLabel: {
        id: "app.peekAdmin.magicButtons.label.text",
        defaultMessage: "Magic Buttons",
    },
    peekAdminBetaFeaturesLabel: {
        id: "app.peekAdmin.betaFeatures.label.text",
        defaultMessage: "Beta Features",
    },
    communityOption: {
        id: "app.peekAdmin.community.option.text",
        defaultMessage: "Community",
    },
    userOption: {
        id: "app.peekAdmin.user.option.text",
        defaultMessage: "User",
    },
    organizationOption: {
        id: "app.peekAdmin.organization.option.text",
        defaultMessage: "Organization",
    },
    magicButtonOption: {
        id: "app.peekAdmin.user.option.text",
        defaultMessage: "Magic Button",
    },
    betaFeatureOption: {
        id: "app.peekAdmin.organization.option.text",
        defaultMessage: "Beta Feature",
    },
});
export default messages;
